/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { CompanySourceEntity } from './legacy';
import { InactiveReason } from './legacy';
export type AccountsFilter = {
  bdrUserIds: Array<number>;
  csmUserIds: Array<number>;
  ids: Array<string>;
  name?: string | null | undefined;
  names: Array<string>;
};

export type AccountsList = {
  limit?: number | null | undefined;
  order?: AccountsSort | null | undefined;
  skip?: number | null | undefined;
};

export type AccountsSort = {
  key: AccountsSortKeys;
  type: SortType;
};

export enum AccountsSortKeys {
  name = 'name'
}

export type AdditionalFieldsFeeInput = {
  field: CommissionFieldType;
  rate: number;
  value: boolean;
};

export type AddressInput = {
  addressLine1?: string | null | undefined;
  addressLine2?: string | null | undefined;
  addressType?: string | null | undefined;
  city?: string | null | undefined;
  countryCode?: string | null | undefined;
  extraInformation?: string | null | undefined;
  postalCode?: string | null | undefined;
  region?: string | null | undefined;
  streetName?: string | null | undefined;
  streetNumber?: string | null | undefined;
};

export type BankDetailsInput = {
  accountNumber?: string | null | undefined;
  address?: string | null | undefined;
  bankNumber?: string | null | undefined;
  ibanNumber?: string | null | undefined;
  name?: string | null | undefined;
  sortCode?: string | null | undefined;
};

export type ChangePasswordInput = {
  currentPassword: string;
  newPassword: string;
};

export enum CommissionFieldType {
  ExpenditureType = 'ExpenditureType',
  Image2Line = 'Image2Line',
  LowValue = 'LowValue',
  Physical = 'Physical',
  Reissue = 'Reissue'
}

export enum CommissionLogicType {
  Accumulate = 'Accumulate',
  Max = 'Max'
}

export type CommissionRatesInput = {
  accountId: string;
  feeModal: Array<FeeModalInput>;
  logicType: CommissionLogicType;
};

export enum CompanieSortKeys {
  countryCode = 'countryCode',
  createdAt = 'createdAt',
  name = 'name'
}

export type CompaniesAttachmentFilterInput = {
  ids?: Array<string | null | undefined> | null | undefined;
};

export type CompaniesFilter = {
  accountIds?: Array<string> | null | undefined;
  countryCodes?: Array<string> | null | undefined;
  coupaEnabled?: Array<CoupaStatus> | null | undefined;
  enabledProducts?: Array<CompanyProducts> | null | undefined;
  ids?: Array<string> | null | undefined;
  inactiveReasons?: Array<InactiveReason> | null | undefined;
  names?: Array<string> | null | undefined;
  partialExemptionType?: PartialExemptionType | null | undefined;
  sftpPath?: string | null | undefined;
  statuses?: Array<CompanyStatus> | null | undefined;
};

export type CompaniesList = {
  limit?: number | null | undefined;
  order?: CompaniesSort | null | undefined;
  skip?: number | null | undefined;
};

export type CompaniesSort = {
  key: CompanieSortKeys;
  type: SortType;
};

export type CompanyAttachmentInput = {
  file: any;
};

export enum CompanyProducts {
  apai = 'apai',
  einvoicing = 'einvoicing',
  vat = 'vat'
}

export { CompanySourceEntity };

export enum CompanyStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum CompanyType {
  Client = 'Client',
  Prospect = 'Prospect',
  Testing = 'Testing'
}

export type ConcurAccountsFilter = {
  accountIds: Array<string>;
  ids: Array<number>;
  isActive?: boolean | null | undefined;
};

export type ConcurAccountsList = {
  limit?: number | null | undefined;
  order?: ConcurAccountsSort | null | undefined;
  skip?: number | null | undefined;
};

export type ConcurAccountsSort = {
  key: ConcurAccountsSortKeys;
  type: SortType;
};

export enum ConcurAccountsSortKeys {
  fetchOrder = 'fetchOrder',
  id = 'id',
  isActive = 'isActive'
}

export enum ConcurFetchStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  Failed = 'Failed',
  InProcess = 'InProcess',
  Pending = 'Pending'
}

export type ConcurHistoryList = {
  limit?: number | null | undefined;
  order?: ConcurHistorySort | null | undefined;
  skip?: number | null | undefined;
};

export type ConcurHistorySort = {
  key: ConcurHistorySortKeys;
  type: SortType;
};

export enum ConcurHistorySortKeys {
  createdAt = 'createdAt',
  fetchDate = 'fetchDate',
  status = 'status'
}

export type ContactInput = {
  email?: string | null | undefined;
  linkedIn?: string | null | undefined;
  mobile?: string | null | undefined;
  name?: string | null | undefined;
  phone?: string | null | undefined;
};

export enum CoupaStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  NEVER_ENABLED = 'NEVER_ENABLED'
}

export type CreateAccountInput = {
  bdrUserId?: number | null | undefined;
  csmUserId?: number | null | undefined;
  name: string;
};

export type CreateCompanyInput = {
  accountName: string;
  address?: AddressInput | null | undefined;
  addressVariations?: Array<AddressInput> | null | undefined;
  bankDetails?: BankDetailsInput | null | undefined;
  companySourceEntity?: CompanySourceEntity | null | undefined;
  contacts?: Array<ContactInput> | null | undefined;
  countryCode: string;
  enabledProducts?: Array<CompanyProducts> | null | undefined;
  inactiveDescription?: string | null | undefined;
  inactiveReason?: InactiveReason | null | undefined;
  name: string;
  nameVariations?: Array<string> | null | undefined;
  partialExemption: boolean;
  partialExemptionType?: PartialExemptionType | null | undefined;
  registeredCountries?: Array<RegisteredCountryInput> | null | undefined;
  status?: CompanyStatus | null | undefined;
  type?: CompanyType | null | undefined;
  vatNumber?: string | null | undefined;
  vatPortals?: Array<VatPortalInput> | null | undefined;
};

export type DeleteCompanyAttachmentInput = {
  companyId: string;
  id: string;
};

export enum ExpenditureType {
  AP = 'AP',
  TnE = 'TnE'
}

export type ExpenditureTypeFeeInput = {
  field: CommissionFieldType;
  rate: number;
  value: string;
};

export type FeeModalInput = {
  additionalFees: Array<AdditionalFieldsFeeInput>;
  baseFee: ExpenditureTypeFeeInput;
};

export type GetNextFetchingInput = {
  accountId: string;
  fetchStartDate: string | Date;
};

export { InactiveReason };

export type InviteUserInput = {
  companiesIds: Array<string>;
  email: string;
  role: UserRole;
};

export enum PartialExemptionType {
  Company = 'Company',
  Team = 'Team'
}

export type RegisteredCountriesFilterInput = {
  registeredAt?: RegistrationDateRange | null | undefined;
};

export type RegisteredCountryInput = {
  countryCode: string;
  registrationPeriod: RegistrationPeriodInput;
  vatNumber: string;
};

export type RegistrationDateRange = {
  from?: string | Date | null | undefined;
  to?: string | Date | null | undefined;
};

export type RegistrationPeriodInput = {
  from?: string | Date | null | undefined;
  to?: string | Date | null | undefined;
};

export type ResendInvitationInput = {
  userId: number;
};

export type SetupCoupaIntegrationInput = {
  clientInstanceName: string;
  companyId: string;
};

export enum SortType {
  asc = 'asc',
  desc = 'desc'
}

export type TriggerConcurFetchingInput = {
  accountId: string;
  periodEnd: string | Date;
  periodStart: string | Date;
};

export type UpdateCompanyInput = {
  accountName: string;
  address?: AddressInput | null | undefined;
  addressVariations?: Array<AddressInput> | null | undefined;
  bankDetails?: BankDetailsInput | null | undefined;
  companySourceEntity?: CompanySourceEntity | null | undefined;
  contacts?: Array<ContactInput> | null | undefined;
  countryCode: string;
  enabledProducts?: Array<CompanyProducts> | null | undefined;
  id: string;
  inactiveDescription?: string | null | undefined;
  inactiveReason?: InactiveReason | null | undefined;
  name: string;
  nameVariations?: Array<string> | null | undefined;
  partialExemption?: boolean | null | undefined;
  partialExemptionType?: PartialExemptionType | null | undefined;
  registeredCountries?: Array<RegisteredCountryInput> | null | undefined;
  status?: CompanyStatus | null | undefined;
  type?: CompanyType | null | undefined;
  vatNumber?: string | null | undefined;
  vatPortals?: Array<VatPortalInput> | null | undefined;
};

export type UpdateConcurAccountInput = {
  accountId: string;
  fetchStartDate?: string | Date | null | undefined;
  isActive: boolean;
};

export type UpdateCoupaIntegrationInput = {
  clientInstanceName: string;
  companyId: string;
  password?: string | null | undefined;
};

export type UpdateUserInput = {
  companyIds: Array<string>;
  firstName?: string | null | undefined;
  id: number;
  lastName?: string | null | undefined;
  role: UserRole;
};

export type UploadMediaCompanyDocumentsInput = {
  companyId?: string | null | undefined;
  files: Array<CompanyAttachmentInput>;
};

export type UpsertCompanyAgreementInput = {
  attachments: Array<string>;
  companyId: string;
  id?: string | null | undefined;
};

export type UpsertCompanyPowerOfAttorneyInput = {
  attachments: Array<string>;
  companyId: string;
  countryCode: string;
  id?: string | null | undefined;
};

export type UpsertCompanyTaxCertificateInput = {
  attachments: Array<string>;
  companyId: string;
  endDate: string | Date;
  id?: string | null | undefined;
  startDate: string | Date;
};

/** this enum is used to check if the user has access to the resource (authorization) and also responsible of the user׳s scope (internal users see all data and external user see only their data) */
export enum UserRole {
  /** Internal user role with the highest access to all resources */
  Admin = 'Admin',
  /** Internal user role with limited access to specific resources */
  Analyst = 'Analyst',
  /** internal user role with highest access to specific resources */
  System = 'System',
  /** External user role with limited access to specific resources */
  User = 'User'
}

export type UserSort = {
  key: UserSortKeys;
  type: SortType;
};

export enum UserSortKeys {
  createdAt = 'createdAt',
  email = 'email',
  firstName = 'firstName',
  lastName = 'lastName',
  role = 'role',
  updatedAt = 'updatedAt'
}

export enum UserStatus {
  Active = 'Active',
  Invited = 'Invited'
}

export type UsersFilter = {
  companiesIds: Array<string>;
  emailContains?: string | null | undefined;
  emails: Array<string>;
  firstNames: Array<string>;
  ids: Array<number>;
  lastNames: Array<string>;
  roles: Array<UserRole>;
  status: Array<UserStatus>;
};

export type UsersList = {
  limit?: number | null | undefined;
  order?: UserSort | null | undefined;
  skip?: number | null | undefined;
};

export type VatPortalInput = {
  id: string | number;
  type?: VatPortalType | null | undefined;
};

export enum VatPortalType {
  HMRC = 'HMRC'
}

export type UpdateConcurAccount_updateConcurAccount_account = { __typename: 'Account', id: string, name: string };

export type UpdateConcurAccount_updateConcurAccount_nextFetch = { __typename: 'ConcurHistory', fetchDate: string, periodStart: string, periodEnd: string, status: ConcurFetchStatus };

export type UpdateConcurAccount_updateConcurAccount_history = { __typename: 'ConcurHistory', fetchDate: string, periodStart: string, periodEnd: string, status: ConcurFetchStatus };

export type UpdateConcurAccount_updateConcurAccount = { __typename: 'ConcurAccount', id: number, isActive: boolean, fetchOrder: number | null, fetchStartDate: string | null, account: UpdateConcurAccount_updateConcurAccount_account, nextFetch: UpdateConcurAccount_updateConcurAccount_nextFetch | null, history: Array<UpdateConcurAccount_updateConcurAccount_history> };

export type UpdateConcurAccount = { updateConcurAccount: UpdateConcurAccount_updateConcurAccount };


export type UpdateConcurAccountVariables = Exact<{
  input: UpdateConcurAccountInput;
}>;

export type ConcurAccounts_concurAccounts_metaData = { __typename: 'ListMetaData', count: number };

export type ConcurAccounts_concurAccounts_objects_account = { __typename: 'Account', id: string, name: string };

export type ConcurAccounts_concurAccounts_objects_nextFetch = { __typename: 'ConcurHistory', fetchDate: string, periodStart: string, periodEnd: string, status: ConcurFetchStatus };

export type ConcurAccounts_concurAccounts_objects_history = { __typename: 'ConcurHistory', fetchDate: string, periodStart: string, periodEnd: string, status: ConcurFetchStatus, resultsS3Path: string | null, fileName: string | null };

export type ConcurAccounts_concurAccounts_objects = { __typename: 'ConcurAccount', id: number, isActive: boolean, fetchOrder: number | null, fetchStartDate: string | null, account: ConcurAccounts_concurAccounts_objects_account, nextFetch: ConcurAccounts_concurAccounts_objects_nextFetch | null, history: Array<ConcurAccounts_concurAccounts_objects_history> };

export type ConcurAccounts_concurAccounts = { __typename: 'ConcurAccountsListResponse', metaData: ConcurAccounts_concurAccounts_metaData, objects: Array<ConcurAccounts_concurAccounts_objects | null> };

export type ConcurAccounts = { concurAccounts: ConcurAccounts_concurAccounts | null };


export type ConcurAccountsVariables = Exact<{
  list: ConcurAccountsList;
  filter: ConcurAccountsFilter;
  historyList?: ConcurHistoryList | null | undefined;
}>;

export type GetCoupaCompanies_companies_objects_account = { __typename: 'Account', id: string, name: string };

export type GetCoupaCompanies_companies_objects = { __typename: 'Company', id: string, name: string, coupaEnabled: CoupaStatus, account: GetCoupaCompanies_companies_objects_account };

export type GetCoupaCompanies_companies_metaData = { __typename: 'ListMetaData', count: number };

export type GetCoupaCompanies_companies = { __typename: 'CompaniesListResponse', objects: Array<GetCoupaCompanies_companies_objects | null>, metaData: GetCoupaCompanies_companies_metaData };

export type GetCoupaCompanies = { companies: GetCoupaCompanies_companies | null };


export type GetCoupaCompaniesVariables = Exact<{
  list: CompaniesList;
  filter: CompaniesFilter;
}>;

export type GetCoupaIntegration_getCoupaIntegration = { __typename: 'CoupaIntegration', login: string, clientInstanceName: string };

export type GetCoupaIntegration = { getCoupaIntegration: GetCoupaIntegration_getCoupaIntegration | null };


export type GetCoupaIntegrationVariables = Exact<{
  companyId: string;
}>;

export type GetNextFetching_getNextFetching = { __typename: 'NextFetchingResponse', fetchDate: string, periodStart: string, periodEnd: string };

export type GetNextFetching = { getNextFetching: GetNextFetching_getNextFetching };


export type GetNextFetchingVariables = Exact<{
  input: GetNextFetchingInput;
}>;

export type RemoveCoupaIntegration = { removeCoupaIntegration: any };


export type RemoveCoupaIntegrationVariables = Exact<{
  companyId: string;
}>;

export type SetupCoupaIntegration_setupCoupaIntegration = { __typename: 'CoupaIntegrationCredentials', login: string, password: string };

export type SetupCoupaIntegration = { setupCoupaIntegration: SetupCoupaIntegration_setupCoupaIntegration };


export type SetupCoupaIntegrationVariables = Exact<{
  input: SetupCoupaIntegrationInput;
}>;

export type TriggerConcurFetching_triggerConcurFetching = { __typename: 'ConcurHistory', pullId: string, accountId: string };

export type TriggerConcurFetching = { triggerConcurFetching: TriggerConcurFetching_triggerConcurFetching };


export type TriggerConcurFetchingVariables = Exact<{
  input: TriggerConcurFetchingInput;
}>;

export type UpdateCoupaIntegration = { updateCoupaIntegration: any };


export type UpdateCoupaIntegrationVariables = Exact<{
  input: UpdateCoupaIntegrationInput;
}>;

export type DivaAuth_divaAuthToken = { __typename: 'DivaAuthToken', access_token: string, expires_in: number, token_type: string };

export type DivaAuth = { divaAuthToken: DivaAuth_divaAuthToken };


export type DivaAuthVariables = Exact<{ [key: string]: never; }>;

export type Accounts_accounts_metaData = { __typename: 'ListMetaData', count: number };

export type Accounts_accounts_objects_commissionRates_fees_additionalFees = { __typename: 'AdditionalFieldsFee', field: CommissionFieldType, rate: number, value: boolean };

export type Accounts_accounts_objects_commissionRates_fees_baseFee = { __typename: 'ExpenditureTypeFee', field: CommissionFieldType, rate: number, value: ExpenditureType };

export type Accounts_accounts_objects_commissionRates_fees = { __typename: 'FeeModal', additionalFees: Array<Accounts_accounts_objects_commissionRates_fees_additionalFees>, baseFee: Accounts_accounts_objects_commissionRates_fees_baseFee };

export type Accounts_accounts_objects_commissionRates = { __typename: 'CommissionRates', logicType: CommissionLogicType, fees: Array<Accounts_accounts_objects_commissionRates_fees> };

export type Accounts_accounts_objects = { __typename: 'Account', id: string, name: string, commissionRates: Accounts_accounts_objects_commissionRates | null };

export type Accounts_accounts = { __typename: 'AccountsListResponse', metaData: Accounts_accounts_metaData, objects: Array<Accounts_accounts_objects | null> };

export type Accounts = { accounts: Accounts_accounts | null };


export type AccountsVariables = Exact<{
  list: AccountsList;
  filter: AccountsFilter;
}>;

export type CreateAccount_createAccount = { __typename: 'Account', id: string, name: string };

export type CreateAccount = { createAccount: CreateAccount_createAccount | null };


export type CreateAccountVariables = Exact<{
  input: CreateAccountInput;
}>;

export type CreateCommissionRates_createCommissionRates_fees_additionalFees = { __typename: 'AdditionalFieldsFee', field: CommissionFieldType, rate: number, value: boolean };

export type CreateCommissionRates_createCommissionRates_fees_baseFee = { __typename: 'ExpenditureTypeFee', field: CommissionFieldType, rate: number, value: ExpenditureType };

export type CreateCommissionRates_createCommissionRates_fees = { __typename: 'FeeModal', additionalFees: Array<CreateCommissionRates_createCommissionRates_fees_additionalFees>, baseFee: CreateCommissionRates_createCommissionRates_fees_baseFee };

export type CreateCommissionRates_createCommissionRates = { __typename: 'CommissionRates', logicType: CommissionLogicType, fees: Array<CreateCommissionRates_createCommissionRates_fees> };

export type CreateCommissionRates = { createCommissionRates: CreateCommissionRates_createCommissionRates | null };


export type CreateCommissionRatesVariables = Exact<{
  input: CommissionRatesInput;
}>;

export type UpdateCommissionRates_updateCommissionRates_fees_additionalFees = { __typename: 'AdditionalFieldsFee', field: CommissionFieldType, rate: number, value: boolean };

export type UpdateCommissionRates_updateCommissionRates_fees_baseFee = { __typename: 'ExpenditureTypeFee', field: CommissionFieldType, rate: number, value: ExpenditureType };

export type UpdateCommissionRates_updateCommissionRates_fees = { __typename: 'FeeModal', additionalFees: Array<UpdateCommissionRates_updateCommissionRates_fees_additionalFees>, baseFee: UpdateCommissionRates_updateCommissionRates_fees_baseFee };

export type UpdateCommissionRates_updateCommissionRates = { __typename: 'CommissionRates', logicType: CommissionLogicType, fees: Array<UpdateCommissionRates_updateCommissionRates_fees> };

export type UpdateCommissionRates = { updateCommissionRates: UpdateCommissionRates_updateCommissionRates | null };


export type UpdateCommissionRatesVariables = Exact<{
  input: CommissionRatesInput;
}>;

export type AgreementsNew_companies_objects_agreements_metaData = { __typename: 'ListMetaData', count: number };

export type AgreementsNew_companies_objects_agreements_objects_attachments_metaData = { __typename: 'ListMetaData', count: number };

export type AgreementsNew_companies_objects_agreements_objects_attachments_objects = { __typename: 'CompanyAttachment', id: string | null, companyDocumentId: string | null, mediaId: string, fileName: string | null, createdAt: string };

export type AgreementsNew_companies_objects_agreements_objects_attachments = { __typename: 'CompanyAttachmentList', metaData: AgreementsNew_companies_objects_agreements_objects_attachments_metaData, objects: Array<AgreementsNew_companies_objects_agreements_objects_attachments_objects | null> };

export type AgreementsNew_companies_objects_agreements_objects = { __typename: 'Agreement', id: string, companyId: string, createdAt: string, updatedAt: string, attachments: AgreementsNew_companies_objects_agreements_objects_attachments };

export type AgreementsNew_companies_objects_agreements = { __typename: 'AgreementList', metaData: AgreementsNew_companies_objects_agreements_metaData, objects: Array<AgreementsNew_companies_objects_agreements_objects | null> };

export type AgreementsNew_companies_objects = { __typename: 'Company', agreements: AgreementsNew_companies_objects_agreements | null };

export type AgreementsNew_companies = { __typename: 'CompaniesListResponse', objects: Array<AgreementsNew_companies_objects | null> };

export type AgreementsNew = { companies: AgreementsNew_companies | null };


export type AgreementsNewVariables = Exact<{
  list: CompaniesList;
  filter: CompaniesFilter;
  agreementsFilter?: CompaniesAttachmentFilterInput | null | undefined;
}>;

export type RemoveAgreementNew_deleteCompanyAgreement = { __typename: 'Agreement', id: string };

export type RemoveAgreementNew = { deleteCompanyAgreement: RemoveAgreementNew_deleteCompanyAgreement | null };


export type RemoveAgreementNewVariables = Exact<{
  input: DeleteCompanyAttachmentInput;
}>;

export type SaveAgreementNew_upsertCompanyAgreement = { __typename: 'Agreement', id: string };

export type SaveAgreementNew = { upsertCompanyAgreement: SaveAgreementNew_upsertCompanyAgreement | null };


export type SaveAgreementNewVariables = Exact<{
  input: UpsertCompanyAgreementInput;
}>;

export type CompaniesOverview_companies_metaData = { __typename: 'ListMetaData', count: number };

export type CompaniesOverview_companies_objects_registeredCountries_objects_registrationPeriod = { __typename: 'RegistrationPeriod', from: string | null, to: string | null };

export type CompaniesOverview_companies_objects_registeredCountries_objects = { __typename: 'RegisteredCountry', countryCode: string, registrationPeriod: CompaniesOverview_companies_objects_registeredCountries_objects_registrationPeriod };

export type CompaniesOverview_companies_objects_registeredCountries = { __typename: 'RegisteredCountriesList', objects: Array<CompaniesOverview_companies_objects_registeredCountries_objects | null> };

export type CompaniesOverview_companies_objects = { __typename: 'Company', id: string, name: string, createdAt: string, countryCode: string, partialExemption: boolean | null, registeredCountries: CompaniesOverview_companies_objects_registeredCountries | null };

export type CompaniesOverview_companies = { __typename: 'CompaniesListResponse', metaData: CompaniesOverview_companies_metaData, objects: Array<CompaniesOverview_companies_objects | null> };

export type CompaniesOverview = { companies: CompaniesOverview_companies | null };


export type CompaniesOverviewVariables = Exact<{
  list: CompaniesList;
  filter: CompaniesFilter;
  registeredCountriesFilter2?: RegisteredCountriesFilterInput | null | undefined;
}>;

export type Companies_companies_metaData = { __typename: 'ListMetaData', count: number };

export type Companies_companies_objects_addressVariations = { __typename: 'Address', addressType: string | null, addressLine1: string | null, addressLine2: string | null, streetName: string | null, streetNumber: string | null, extraInformation: string | null, city: string | null, region: string | null, postalCode: string | null, countryCode: string | null };

export type Companies_companies_objects_account = { __typename: 'Account', id: string, name: string };

export type Companies_companies_objects_contacts = { __typename: 'Contact', name: string | null, email: string | null, phone: string | null, mobile: string | null, linkedIn: string | null };

export type Companies_companies_objects_registeredCountries_metaData = { __typename: 'ListMetaData', count: number };

export type Companies_companies_objects_registeredCountries_objects_registrationPeriod = { __typename: 'RegistrationPeriod', from: string | null, to: string | null };

export type Companies_companies_objects_registeredCountries_objects = { __typename: 'RegisteredCountry', countryCode: string, vatNumber: string | null, registrationPeriod: Companies_companies_objects_registeredCountries_objects_registrationPeriod };

export type Companies_companies_objects_registeredCountries = { __typename: 'RegisteredCountriesList', metaData: Companies_companies_objects_registeredCountries_metaData, objects: Array<Companies_companies_objects_registeredCountries_objects | null> };

export type Companies_companies_objects_address = { __typename: 'Address', addressType: string | null, addressLine1: string | null, addressLine2: string | null, extraInformation: string | null, streetName: string | null, streetNumber: string | null, city: string | null, region: string | null, postalCode: string | null, countryCode: string | null };

export type Companies_companies_objects_bankDetails = { __typename: 'BankDetails', name: string | null, accountNumber: string | null, ibanNumber: string | null, bankNumber: string | null, sortCode: string | null };

export type Companies_companies_objects_vatPortals = { __typename: 'VatPortal', type: VatPortalType | null, id: string | null };

export type Companies_companies_objects = { __typename: 'Company', nameVariations: Array<string> | null, id: string, name: string, countryCode: string, partialExemption: boolean | null, enabledProducts: Array<CompanyProducts> | null, companySourceEntity: CompanySourceEntity | null, type: CompanyType, status: CompanyStatus, inactiveReason: InactiveReason | null, inactiveDescription: string | null, vatNumber: string | null, createdAt: string, partialExemptionType: PartialExemptionType | null, addressVariations: Array<Companies_companies_objects_addressVariations> | null, account: Companies_companies_objects_account, contacts: Array<Companies_companies_objects_contacts> | null, registeredCountries: Companies_companies_objects_registeredCountries | null, address: Companies_companies_objects_address | null, bankDetails: Companies_companies_objects_bankDetails | null, vatPortals: Array<Companies_companies_objects_vatPortals | null> | null };

export type Companies_companies = { __typename: 'CompaniesListResponse', metaData: Companies_companies_metaData, objects: Array<Companies_companies_objects | null> };

export type Companies = { companies: Companies_companies | null };


export type CompaniesVariables = Exact<{
  list: CompaniesList;
  filter: CompaniesFilter;
  registeredCountriesFilter2?: RegisteredCountriesFilterInput | null | undefined;
}>;

export type CreateCompany_createCompany_account = { __typename: 'Account', id: string, name: string };

export type CreateCompany_createCompany_contacts = { __typename: 'Contact', name: string | null, email: string | null, phone: string | null, mobile: string | null, linkedIn: string | null };

export type CreateCompany_createCompany_registeredCountries_objects_registrationPeriod = { __typename: 'RegistrationPeriod', from: string | null, to: string | null };

export type CreateCompany_createCompany_registeredCountries_objects = { __typename: 'RegisteredCountry', countryCode: string, registrationPeriod: CreateCompany_createCompany_registeredCountries_objects_registrationPeriod };

export type CreateCompany_createCompany_registeredCountries = { __typename: 'RegisteredCountriesList', objects: Array<CreateCompany_createCompany_registeredCountries_objects | null> };

export type CreateCompany_createCompany_address = { __typename: 'Address', addressType: string | null, addressLine1: string | null, addressLine2: string | null, extraInformation: string | null, streetName: string | null, streetNumber: string | null, city: string | null, region: string | null, postalCode: string | null, countryCode: string | null };

export type CreateCompany_createCompany_bankDetails = { __typename: 'BankDetails', name: string | null, accountNumber: string | null, ibanNumber: string | null, bankNumber: string | null, sortCode: string | null };

export type CreateCompany_createCompany_vatPortals = { __typename: 'VatPortal', type: VatPortalType | null, id: string | null };

export type CreateCompany_createCompany = { __typename: 'Company', id: string, name: string, vatNumber: string | null, countryCode: string, createdAt: string, partialExemptionType: PartialExemptionType | null, enabledProducts: Array<CompanyProducts> | null, companySourceEntity: CompanySourceEntity | null, type: CompanyType, status: CompanyStatus, inactiveReason: InactiveReason | null, inactiveDescription: string | null, account: CreateCompany_createCompany_account, contacts: Array<CreateCompany_createCompany_contacts> | null, registeredCountries: CreateCompany_createCompany_registeredCountries | null, address: CreateCompany_createCompany_address | null, bankDetails: CreateCompany_createCompany_bankDetails | null, vatPortals: Array<CreateCompany_createCompany_vatPortals | null> | null };

export type CreateCompany = { createCompany: CreateCompany_createCompany | null };


export type CreateCompanyVariables = Exact<{
  input: CreateCompanyInput;
  filter?: RegisteredCountriesFilterInput | null | undefined;
}>;

export type PoasNew_companies_objects_powerOfAttorneys_metaData = { __typename: 'ListMetaData', count: number };

export type PoasNew_companies_objects_powerOfAttorneys_objects_attachments_metaData = { __typename: 'ListMetaData', count: number };

export type PoasNew_companies_objects_powerOfAttorneys_objects_attachments_objects = { __typename: 'CompanyAttachment', id: string | null, companyDocumentId: string | null, mediaId: string, fileName: string | null, createdAt: string };

export type PoasNew_companies_objects_powerOfAttorneys_objects_attachments = { __typename: 'CompanyAttachmentList', metaData: PoasNew_companies_objects_powerOfAttorneys_objects_attachments_metaData, objects: Array<PoasNew_companies_objects_powerOfAttorneys_objects_attachments_objects | null> };

export type PoasNew_companies_objects_powerOfAttorneys_objects = { __typename: 'PowerOfAttorney', id: string, companyId: string, countryCode: string, countryDescription: string, createdAt: string, updatedAt: string, attachments: PoasNew_companies_objects_powerOfAttorneys_objects_attachments };

export type PoasNew_companies_objects_powerOfAttorneys = { __typename: 'PowerOfAttorneyList', metaData: PoasNew_companies_objects_powerOfAttorneys_metaData, objects: Array<PoasNew_companies_objects_powerOfAttorneys_objects | null> };

export type PoasNew_companies_objects = { __typename: 'Company', powerOfAttorneys: PoasNew_companies_objects_powerOfAttorneys | null };

export type PoasNew_companies = { __typename: 'CompaniesListResponse', objects: Array<PoasNew_companies_objects | null> };

export type PoasNew = { companies: PoasNew_companies | null };


export type PoasNewVariables = Exact<{
  list: CompaniesList;
  filter: CompaniesFilter;
  poaFilter?: CompaniesAttachmentFilterInput | null | undefined;
}>;

export type RemovePoaNew_deleteCompanyPowerOfAttorney = { __typename: 'PowerOfAttorney', id: string };

export type RemovePoaNew = { deleteCompanyPowerOfAttorney: RemovePoaNew_deleteCompanyPowerOfAttorney | null };


export type RemovePoaNewVariables = Exact<{
  input: DeleteCompanyAttachmentInput;
}>;

export type SavePoaNew_upsertCompanyPowerOfAttorney = { __typename: 'PowerOfAttorney', id: string };

export type SavePoaNew = { upsertCompanyPowerOfAttorney: SavePoaNew_upsertCompanyPowerOfAttorney | null };


export type SavePoaNewVariables = Exact<{
  input: UpsertCompanyPowerOfAttorneyInput;
}>;

export type RemoveTcNew_deleteCompanyTaxCertificate = { __typename: 'TaxCertificate', id: string };

export type RemoveTcNew = { deleteCompanyTaxCertificate: RemoveTcNew_deleteCompanyTaxCertificate | null };


export type RemoveTcNewVariables = Exact<{
  input: DeleteCompanyAttachmentInput;
}>;

export type SaveTcNew_upsertCompanyTaxCertificate = { __typename: 'TaxCertificate', id: string };

export type SaveTcNew = { upsertCompanyTaxCertificate: SaveTcNew_upsertCompanyTaxCertificate | null };


export type SaveTcNewVariables = Exact<{
  input: UpsertCompanyTaxCertificateInput;
}>;

export type TcsNew_companies_objects_taxCertificates_metaData = { __typename: 'ListMetaData', count: number };

export type TcsNew_companies_objects_taxCertificates_objects_attachments_metaData = { __typename: 'ListMetaData', count: number };

export type TcsNew_companies_objects_taxCertificates_objects_attachments_objects = { __typename: 'CompanyAttachment', id: string | null, companyDocumentId: string | null, mediaId: string, fileName: string | null, createdAt: string };

export type TcsNew_companies_objects_taxCertificates_objects_attachments = { __typename: 'CompanyAttachmentList', metaData: TcsNew_companies_objects_taxCertificates_objects_attachments_metaData, objects: Array<TcsNew_companies_objects_taxCertificates_objects_attachments_objects | null> };

export type TcsNew_companies_objects_taxCertificates_objects = { __typename: 'TaxCertificate', id: string, companyId: string, startDate: string, endDate: string, createdAt: string, updatedAt: string, attachments: TcsNew_companies_objects_taxCertificates_objects_attachments };

export type TcsNew_companies_objects_taxCertificates = { __typename: 'TaxCertificateList', metaData: TcsNew_companies_objects_taxCertificates_metaData, objects: Array<TcsNew_companies_objects_taxCertificates_objects | null> };

export type TcsNew_companies_objects = { __typename: 'Company', taxCertificates: TcsNew_companies_objects_taxCertificates | null };

export type TcsNew_companies = { __typename: 'CompaniesListResponse', objects: Array<TcsNew_companies_objects | null> };

export type TcsNew = { companies: TcsNew_companies | null };


export type TcsNewVariables = Exact<{
  list: CompaniesList;
  filter: CompaniesFilter;
  tcFilter?: CompaniesAttachmentFilterInput | null | undefined;
}>;

export type UpdateCompany_updateCompany_account = { __typename: 'Account', id: string, name: string };

export type UpdateCompany_updateCompany_contacts = { __typename: 'Contact', name: string | null, email: string | null, phone: string | null, mobile: string | null, linkedIn: string | null };

export type UpdateCompany_updateCompany_registeredCountries_objects_registrationPeriod = { __typename: 'RegistrationPeriod', from: string | null, to: string | null };

export type UpdateCompany_updateCompany_registeredCountries_objects = { __typename: 'RegisteredCountry', countryCode: string, vatNumber: string | null, registrationPeriod: UpdateCompany_updateCompany_registeredCountries_objects_registrationPeriod };

export type UpdateCompany_updateCompany_registeredCountries = { __typename: 'RegisteredCountriesList', objects: Array<UpdateCompany_updateCompany_registeredCountries_objects | null> };

export type UpdateCompany_updateCompany_address = { __typename: 'Address', addressType: string | null, addressLine1: string | null, addressLine2: string | null, extraInformation: string | null, streetName: string | null, streetNumber: string | null, city: string | null, region: string | null, postalCode: string | null, countryCode: string | null };

export type UpdateCompany_updateCompany_bankDetails = { __typename: 'BankDetails', name: string | null, accountNumber: string | null, ibanNumber: string | null, bankNumber: string | null, sortCode: string | null };

export type UpdateCompany_updateCompany_vatPortals = { __typename: 'VatPortal', type: VatPortalType | null, id: string | null };

export type UpdateCompany_updateCompany = { __typename: 'Company', id: string, name: string, countryCode: string, vatNumber: string | null, createdAt: string, partialExemptionType: PartialExemptionType | null, enabledProducts: Array<CompanyProducts> | null, companySourceEntity: CompanySourceEntity | null, type: CompanyType, status: CompanyStatus, inactiveReason: InactiveReason | null, inactiveDescription: string | null, account: UpdateCompany_updateCompany_account, contacts: Array<UpdateCompany_updateCompany_contacts> | null, registeredCountries: UpdateCompany_updateCompany_registeredCountries | null, address: UpdateCompany_updateCompany_address | null, bankDetails: UpdateCompany_updateCompany_bankDetails | null, vatPortals: Array<UpdateCompany_updateCompany_vatPortals | null> | null };

export type UpdateCompany = { updateCompany: UpdateCompany_updateCompany | null };


export type UpdateCompanyVariables = Exact<{
  input: UpdateCompanyInput;
  filter?: RegisteredCountriesFilterInput | null | undefined;
}>;

export type GetCompanyEnabledProducts_companies_metaData = { __typename: 'ListMetaData', count: number };

export type GetCompanyEnabledProducts_companies_objects_account = { __typename: 'Account', id: string, name: string };

export type GetCompanyEnabledProducts_companies_objects = { __typename: 'Company', id: string, name: string, countryCode: string, enabledProducts: Array<CompanyProducts> | null, account: GetCompanyEnabledProducts_companies_objects_account };

export type GetCompanyEnabledProducts_companies = { __typename: 'CompaniesListResponse', metaData: GetCompanyEnabledProducts_companies_metaData, objects: Array<GetCompanyEnabledProducts_companies_objects | null> };

export type GetCompanyEnabledProducts = { companies: GetCompanyEnabledProducts_companies | null };


export type GetCompanyEnabledProductsVariables = Exact<{
  list: CompaniesList;
  filter: CompaniesFilter;
}>;

export type GetMediaIdsForCompanies = { uploadMediaCompanyDocuments: Array<string | null> | null };


export type GetMediaIdsForCompaniesVariables = Exact<{
  input: UploadMediaCompanyDocumentsInput;
}>;

export type ChangePassword = { changePassword: any };


export type ChangePasswordVariables = Exact<{
  input: ChangePasswordInput;
}>;

export type InviteUser_inviteUser = { __typename: 'User', id: number };

export type InviteUser = { inviteUser: InviteUser_inviteUser };


export type InviteUserVariables = Exact<{
  input: InviteUserInput;
}>;

export type Me_me_objects_companies = { __typename: 'Company', id: string };

export type Me_me_objects = { __typename: 'User', id: number, firstName: string | null, lastName: string | null, email: string, role: UserRole | null, status: UserStatus, companies: Array<Me_me_objects_companies | null> };

export type Me_me = { __typename: 'UsersListResponse', objects: Array<Me_me_objects | null> };

export type Me = { me: Me_me | null };


export type MeVariables = Exact<{ [key: string]: never; }>;

export type RemoveUser_removeUser = { __typename: 'User', id: number, firstName: string | null, lastName: string | null, email: string };

export type RemoveUser = { removeUser: RemoveUser_removeUser | null };


export type RemoveUserVariables = Exact<{
  userId: number;
}>;

export type ResendInvitation = { resendInvitation: any };


export type ResendInvitationVariables = Exact<{
  input: ResendInvitationInput;
}>;

export type UpdateUser_updateUser_companies = { __typename: 'Company', id: string, name: string };

export type UpdateUser_updateUser = { __typename: 'User', id: number, firstName: string | null, lastName: string | null, email: string, role: UserRole | null, status: UserStatus, companies: Array<UpdateUser_updateUser_companies | null> };

export type UpdateUser = { updateUser: UpdateUser_updateUser | null };


export type UpdateUserVariables = Exact<{
  updateUserInput?: UpdateUserInput | null | undefined;
}>;

export type Users_users_metaData = { __typename: 'ListMetaData', count: number };

export type Users_users_objects_companies = { __typename: 'Company', id: string, name: string, countryCode: string };

export type Users_users_objects = { __typename: 'User', id: number, firstName: string | null, lastName: string | null, email: string, role: UserRole | null, status: UserStatus, companies: Array<Users_users_objects_companies | null> };

export type Users_users = { __typename: 'UsersListResponse', metaData: Users_users_metaData, objects: Array<Users_users_objects | null> };

export type Users = { users: Users_users | null };


export type UsersVariables = Exact<{
  list: UsersList;
  filter: UsersFilter;
}>;
